import { render } from "./SignUpSidebar.vue?vue&type=template&id=043978d4&scoped=true"
import script from "./SignUpSidebar.vue?vue&type=script&lang=js"
export * from "./SignUpSidebar.vue?vue&type=script&lang=js"

import "./SignUpSidebar.vue?vue&type=style&index=0&id=043978d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043978d4"]])

export default __exports__